// Shared fixed positioning for dock collapsed affordances (tab + firefly).
// Extracted from ActivityDockTab for V10 reuse.

import type { CSSProperties } from "react";
import { isHorizontalEdge, type DockEdge } from "./activityDockPositionMath";

export function dockAffordanceRestingStyle(
  edge: DockEdge,
  offsetRatio: number,
  tabWidthPx: number,
  tabHeightPx: number,
): CSSProperties {
  const base: CSSProperties = {
    position: "fixed",
    width: tabWidthPx,
    height: tabHeightPx,
  };
  if (isHorizontalEdge(edge)) {
    return {
      ...base,
      [edge]: 0,
      left: `calc(var(--shell-sidebar-w, 0px) + (100vw - var(--shell-sidebar-w, 0px) - ${tabWidthPx}px) * ${offsetRatio})`,
    };
  }
  if (edge === "left") {
    return {
      ...base,
      left: "var(--shell-sidebar-w, 0px)",
      top: `calc((100vh - ${tabHeightPx}px) * ${offsetRatio})`,
    };
  }
  return {
    ...base,
    [edge]: 0,
    top: `calc((100vh - ${tabHeightPx}px) * ${offsetRatio})`,
  };
}

export function dockAffordanceDragStyle(
  dragPreview: { x: number; y: number },
  tabWidthPx: number,
  tabHeightPx: number,
): CSSProperties {
  return {
    position: "fixed",
    left: dragPreview.x - tabWidthPx / 2,
    top: dragPreview.y - tabHeightPx / 2,
    width: tabWidthPx,
    height: tabHeightPx,
  };
}
